import React, { useEffect, useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full bg-red-600 border-b border-red-700 z-50 shadow-lg transform transition-transform duration-300 animate-in slide-in-from-top" data-id="element-280">
      <div className="max-w-6xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4" data-id="element-281">
        <div className="flex items-center gap-3" data-id="element-282">
          <CountdownTimer compact data-id="element-283" />
          <p className="text-white font-bold text-sm sm:text-base hidden md:block" data-id="element-284">
            Questa offerta termina presto
          </p>
        </div>
        <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-400 text-white font-bold py-1.5 px-6 rounded-full shadow-md transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base whitespace-nowrap w-full sm:w-auto" data-id="element-285">
          ACCEDI ORA
        </button>
      </div>
    </div>;
}